import { FolioView } from '@new/domains/bookings/config/folioViews'

export const parseFolioView = (value: string) =>
  Object.values(FolioView).find(view => view === value) ?? FolioView.internal
